<template>
	<div>
		<div class="row">
			<div class="col-5 mb-4">
				<h1>{{ $t("templates") }}</h1>
			</div>
			<div class="col-7 mb-4">
				<router-link to="/timetables/templates/add" class="float-right btn btn-primary"
					><b-icon icon="plus"></b-icon> {{ $t("new") }}</router-link
				>
			</div>
		</div>

		<Table
			:loading="!loaded"
			:data="templates"
			:cols="[{ key: 'tttemplate_name', heading: 'Name', size: 8 }]"
			:onSelectItem="selectTemplate"
			breakpoint="sm"
		/>
	</div>
</template>

<script>
import Table from "../../../components/Table/Table.vue";

export default {
	components: {
		Table,
	},
	data: function () {
		return {
			templates: [],
			loaded: false,
		};
	},
	mounted() {
		this.loadTemplates();
	},
	methods: {
		loadTemplates: function () {
			this.$cfetch(`${this.$settings.APIBaseURL}/timetable/tttemplate/list`).then((res) => {
				this.templates = res.results;
				this.loaded = true;
			});
		},
		selectTemplate(template) {
			this.$router.push(`/timetables/templates/${template.id}`);
		},
	},
};
</script>
